import api from "../index";

export const GetAllIbApi = (params) => api.get(`admin/getallibuserlist?${params}`);
export const GetAllIBByIdApi = (IBId) => api.get(`admin/getsingleibuser/${IBId}`);
export const IBRejectApproveApi = (data) => api.post('admin/ibrejectedapproved', data);
export const GetCommissionAssignTreeApi = (userId, params) => api.get(`ibusermaster/ib-commission-assign-tree/${userId}?${params}`);
export const GetAllAccountPlanApi = (params) => api.post('planmaster/get-all-plan-for-user', params);